import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { CloseDialogAction } from '../../../components/shared/dialogs/CloseDialogAction';

interface SubmitModalProps {
  openModal: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const SubmitModal: React.FC<SubmitModalProps> = ({ openModal, onConfirm, onCancel }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  const handleCancel = () => {
    onCancel();
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    setOpen(false);
  };

  return (
    <Dialog
      onClose={handleCancel}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle>
        Confirm Save and Submit For Approval
        <CloseDialogAction onCancel={handleCancel} />
      </DialogTitle>
      <DialogContent dividers
        sx={{ p: 0, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="textMD"
          sx={{ my: 4, mx: 6 }}>
          Your count will be saved and then submitted for approval. Please ensure all item counts have been added.
          Once a count is submitted for approval, you cannot change the values.
        </Typography>
        <Typography variant="textMD"
          sx={{ my: 4, mx: 6 }}>
          Are you sure you want to save and submit this count?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ mt: 4, mb: 4, mr: 4 }}>
        <Button variant='bad'
          size="lg"
          onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          variant='primary'
          size="lg"
          onClick={handleConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default SubmitModal;

